/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Y_Offset_LabelInputs */

const en_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical (Y) Offset`)
};

const fr_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decalage vertical (Y)`)
};

const de_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikaler (Y)-Versatz`)
};

const it_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset verticale (Y)`)
};

const ru_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вертикальное (Y) смещение`)
};

const es_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento vertical (Y)`)
};

const zh_cn2_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直 (Y) 偏移`)
};

const ja_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直（Y）オフセット`)
};

const hi_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊर्ध्वाधर (Y) ऑफ़सेट`)
};

const pt_pt2_style_guide_manager_position_y_offset_label = /** @type {(inputs: Style_Guide_Manager_Position_Y_Offset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento vertical (Y)`)
};

/**
* | output |
* | --- |
* | "Vertical (Y) Offset" |
*
* @param {Style_Guide_Manager_Position_Y_Offset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_y_offset_label = /** @type {((inputs?: Style_Guide_Manager_Position_Y_Offset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Y_Offset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_y_offset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_y_offset_label(inputs)
	return en_style_guide_manager_position_y_offset_label(inputs)
});